module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-12.9514adbf.png";